import * as React from 'react'
import { Segment, Container, Header, Divider } from 'semantic-ui-react'
import ContentMol from '../content'
import LinkAtom from '../../atoms/link'

export default class ContactMol extends React.Component<
  { style?: React.CSSProperties },
  {}
> {
  render() {
    return <ContentMol title="" />
  }
}
